<template lang="html">
  <div id="bedroom" class="bedroom">

    <div class="container">
      <div class="row">
        <h2 class="title">{{$t('telas.quartos.titulo')}}</h2>
      </div>

			<!-- <div class="row">
        <div class="col-md-6 col-lg-6 bedroom-item" v-for="item in bedrooms">
          <div class="item">
            <h5> {{ item.name }} </h5>
            <span @click="rota2('BedroomGeneric', item.id)">
              <img :src="item.imagesUrl[0]" :alt="'Tranquilândia -' + item.name">
            </span>
            <div class="row row-btn">
              <div class="col-md-6 col-lg-6 btn btn-ver-mais" @click="rota2('BedroomGeneric', item.id)">
                {{ $t('telas.quartos.botao.informacoes') }}
              </div>
              <div class="col-md-6 col-lg-6 btn btn-reservar" @click="rota('SelectDatesReservation')">
                {{ $t('telas.quartos.botao.reservar') }}
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-md-6 col-lg-6 bedroom-item">
          <div class="item">
            <h5>{{$t('telas.quartos.chale.titulo')}}</h5>
            <span @click="rota('Chale')">
              <img src="@/assets/img/quartos/chale/1.jpg" alt="Tranquilândia - Chalé">
            </span>

            <div class="row row-btn">
              <div class="col-md-6 col-lg-6 btn btn-ver-mais" @click="rota('Chale')">
                {{ $t('telas.quartos.botao.informacoes') }}
              </div>
              <div class="col-md-6 col-lg-6 btn btn-reservar" @click="rota('SelectDatesReservation')">
                {{ $t('telas.quartos.botao.reservar') }}
              </div>
            </div>

          </div> <!-- chale -->
        </div> <!-- bedroom-chale -->

        <div class="col-md-6 col-lg-6 bedroom-item">
          <div class="item">
            <h5>{{$t('telas.quartos.suite.titulo')}}</h5>
            <span @click="rota('Suite')">
              <img src="@/assets/img/quartos/suite1/1.jpg" alt="Tranquilândia - Suite">
            </span>

            <div class="row row-btn">
              <div class="col-md-6 col-lg-6 btn btn-ver-mais" @click="rota('Suite')">
                {{ $t('telas.quartos.botao.informacoes') }}
              </div>
              <div class="col-md-6 col-lg-6 btn btn-reservar" @click="rota('SelectDatesReservation')">
                {{ $t('telas.quartos.botao.reservar') }}
              </div>
            </div>

          </div> <!-- item -->
        </div> <!-- bedroom-item -->
      </div> <!-- row -->

      <div class="row">
        <div class="col-md-6 col-lg-6 bedroom-item">
          <div class="item">
            <h5>{{$t('telas.quartos.quarto_duplo_superior.titulo')}}</h5>

            <span @click="rota('DuploSuperior')">
              <img src="@/assets/img/quartos/duplo1/1.jpg" alt="Tranquilândia - Quarto Duplo Superior">
            </span>

            <div class="row row-btn">
              <div class="col-md-6 col-lg-6 btn btn-ver-mais"  @click="rota('DuploSuperior')">
                {{ $t('telas.quartos.botao.informacoes') }}
              </div>
              <div class="col-md-6 col-lg-6 btn btn-reservar" @click="rota('SelectDatesReservation')">
                {{ $t('telas.quartos.botao.reservar') }}
              </div>
            </div>

          </div> <!-- chale -->
        </div> <!-- bedroom-chale -->

        <div class="col-md-6 col-lg-6 bedroom-item">
          <div class="item">
            <h5>{{$t('telas.quartos.quarto_duplo_terreo.titulo')}}</h5>

            <span @click="rota('DuploTerreo')">
              <img src="@/assets/img/quartos/duplo2/1.jpg" alt="Tranquilândia - Quarto Duplo Térreo">
            </span>

            <div class="row row-btn">
              <div class="col-md-6 col-lg-6 btn btn-ver-mais" @click="rota('DuploTerreo')">
                {{ $t('telas.quartos.botao.informacoes') }}
              </div>
              <div class="col-md-6 col-lg-6 btn btn-reservar" @click="rota('SelectDatesReservation')">
                {{ $t('telas.quartos.botao.reservar') }}
              </div>
            </div>

          </div> <!-- item -->
        </div> <!-- bedroom-item -->
      </div> <!-- row -->

      <div class="row">
        <div class="col-md-6 col-lg-6 bedroom-item">
          <div class="item">
            <h5>{{$t('telas.quartos.suite_deluxe.titulo')}}</h5>

            <span @click="rota('SuiteDeluxe')">
              <img src="@/assets/img/quartos/suite2/1.jpg" alt="Tranquilândia - Suíte Deluxe">
            </span>

            <div class="row row-btn">
              <div class="col-md-6 col-lg-6 btn btn-ver-mais" @click="rota('SuiteDeluxe')">
                {{ $t('telas.quartos.botao.informacoes') }}
              </div>
              <div class="col-md-6 col-lg-6 btn btn-reservar" @click="rota('SelectDatesReservation')">
                {{ $t('telas.quartos.botao.reservar') }}
              </div>
            </div>

          </div> <!-- chale -->
        </div> <!-- bedroom-chale -->
      </div> <!-- row -->

      <reserva :header="true"></reserva>

    </div> <!-- container -->
  </div> <!-- bedroom -->
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'
import { urlBase } from '../../../config/url'

export default {
  name: 'Bedroom',

	data() {
		return {
      urlBase,
      bedrooms: []
		}
	},

  components: {
    reserva
  },

  created() {
		// this.$req.bedroom.getGroupByBedroomType()
		// 		.then(res => {
    //       this.bedrooms = res
    //       this.$store.commit('setBedroomsGroupByType', this.bedrooms)
		// 		}).catch(err => {
		// 			console.error(err)
		// 		})
  },

  methods: {
    rota(route){
      this.$router.push({name: route});
    },
    rota2(route, data){
      this.$router.push({name: route, params: { id: data } });
    },
  },
}
</script>

<style lang="css">
@import url('https://fonts.googleapis.com/css?family=Quicksand');

.bedroom {
  background-image: url('../../assets/img/bg.png');
  background-repeat: repeat;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}

.bedroom div.container div.row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  font-weight: bold;
}

.bedroom div.container div.row .bedroom-item {
  padding: 20px;
}
.bedroom div.container div.row .bedroom-item .item {
  display: block;
  background-color: rgb(23, 162, 184);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.bedroom div.container div.row .bedroom-item .item h5 {
  text-align: center;
  padding-top: 5px;
  font-weight: 500;
  color: white;
}
.bedroom div.container div.row .bedroom-item .item img {
  width: 100%;
  cursor: pointer;
  transition: all 1s;
}
.bedroom div.container div.row .bedroom-item .item img:HOVER {
  filter: opacity(70%);
}
.bedroom div.container div.row .bedroom-item .item .row-btn {
  padding: 0 15px 0 15px;
}
.bedroom div.container div.row .bedroom-item .item .row .btn {
  text-align: center;
  border-radius: 0;
  color: white;
  font-weight: bold;
}
.bedroom div.container div.row .bedroom-item .item .row .btn-ver-mais {
  cursor: pointer;
  background-color: #48AAE5;
  transition: all 0.5s;
}
.bedroom div.container div.row .bedroom-item .item .row .btn-reservar {
  cursor: pointer;
  background-color: #00A852;
  transition: all 0.5s;
}
.bedroom div.container div.row .bedroom-item .item .row .btn-ver-mais:HOVER {
  z-index: 1;
  box-shadow: 3px 0 3px #444;
}
.bedroom div.container div.row .bedroom-item .item .row .btn-reservar:HOVER {
  z-index: 1;
  box-shadow: -3px 0 3px #444;
}

</style>



// WEBPACK FOOTER //
// src/pages/bedroom/Bedroom.vue